import React from "react";
import Location from "../Location/Location";

function EditLocation({
  account_slug,
  project_id,
  projectStatus,
  locations,
  locationId,
  account_id,
  setLocationUpdated,
  projVariables,
  authorizationCode,
}) {
  return (
    <Location
      account_slug={account_slug}
      project_id={project_id}
      projectStatus={projectStatus}
      locations={locations}
      locationId={locationId}
      account_id={account_id}
      setLocationUpdated={setLocationUpdated}
      projVariables={projVariables}
      authorizationCode={authorizationCode}
    />
  );
}

export default EditLocation;
